// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"bdafae28","76":"3a106ea6","180":"c072104c","474":"ccc9dbd0","776":"00e3dd6f","921":"6670c080","984":"d55637a8"}[chunkId] + ".chunk.js";
};